export const ITEMS = [
    "PiScanner is an easy, user-friendly application for extracting useful information from all your business cards.",

    "Need to remember something? PiScanner has got you covered! Record short voice notes instantly and get the tanscribed audio in seconds.",

    "Now, scan your card to get the required data, anywhere, anytime, just by clicking or uploading your card image."
];